import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import styles from "./ProfileTable.module.scss"
import FreelancerDescription from "./components/FreelancerDescription/FreelancerDescription"
import ProfileTableItem from "./ProfileTableItem"
import classNames from "classnames"

const ProfileTable = ({ data, shareButton }) => {
  const skills = data?.skills ?? []
  const [skillsExpanded, setSkillsExpanded] = useState(false)
  const [skillsVisibleCount, setSkillsVisibleCount] = useState(0)
  const skillsMeasureRef = useRef(null)

  useEffect(() => {
    setSkillsExpanded(false)
  }, [skills])

  useLayoutEffect(() => {
    if (!skills.length) {
      setSkillsVisibleCount(0)
      return
    }

    const el = skillsMeasureRef.current
    if (!el) return

    const measure = () => {
      const children = Array.from(el.children)
      const rowTops = []
      let count = 0

      for (const child of children) {
        const top = child.offsetTop
        if (
          !rowTops.length ||
          Math.abs(top - rowTops[rowTops.length - 1]) > 1
        ) {
          rowTops.push(top)
        }
        if (rowTops.length > 2) break
        count += 1
      }

      setSkillsVisibleCount(count)
    }

    const raf = requestAnimationFrame(measure)
    return () => cancelAnimationFrame(raf)
  }, [skills])

  const visibleSkills =
    skillsExpanded || !skillsVisibleCount
      ? skills
      : skills.slice(0, skillsVisibleCount)
  const showSkillsToggle =
    skills.length > 0 &&
    skillsVisibleCount > 0 &&
    skills.length > skillsVisibleCount

  return (
    <div
      className={classNames(styles.profileTableFreelancer, styles.profileTable)}
    >
      <div className={styles.tableItem}>
        <FreelancerDescription
          title="About Freelancer"
          data={data?.description}
          headerAction={shareButton}
        />
      </div>

      <div className={styles.tableItem}>
        <ProfileTableItem
          title="Skills"
          hasData={skills.length > 0}
          anotherUser
        />
        {skills.length > 0 ? (
          <div className={styles.tagsClampWrap}>
            <div className={styles.tagsWrap}>
              {visibleSkills.map((skill, i) => (
                <span key={i} className={styles.tag}>
                  {typeof skill === "string"
                    ? skill
                    : skill?.preferredLabel ?? skill?.name ?? ""}
                </span>
              ))}
            </div>
            <div
              ref={skillsMeasureRef}
              className={classNames(styles.tagsWrap, styles.tagsMeasure)}
            >
              {skills.map((skill, i) => (
                <span key={`measure-${i}`} className={styles.tag}>
                  {typeof skill === "string"
                    ? skill
                    : skill?.preferredLabel ?? skill?.name ?? ""}
                </span>
              ))}
            </div>
            {showSkillsToggle ? (
              <button
                type="button"
                className={styles.toggleButton}
                onClick={() => setSkillsExpanded((prev) => !prev)}
              >
                {skillsExpanded ? "Show less" : "Show more"}
              </button>
            ) : null}
          </div>
        ) : (
          <span className={styles.noInfo}>No skills listed</span>
        )}
      </div>
    </div>
  )
}

export default ProfileTable
